import { Button, Input, Spin } from 'antd';
import React, { useEffect, useState } from 'react'
import { MdPassword } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import AdminNavbar from './Navbar/AdminNavbar';
import { ChangePasswordAdd } from './Api/All_Api';
import axios from 'axios';
import { toast } from 'react-toastify';
import TitleNavbar from './Navbar/TitleNavbar';

const ChangePassword = () => {
     const sessionYear = sessionStorage.getItem('sessionYear');
      const year = sessionYear
      const branchId = sessionStorage.getItem('branchId');
      const userId = sessionStorage.getItem('userId');
      //console.log("User ID:",userId);
      
    const navigate = useNavigate();
    
        useEffect(() => {
          if (!sessionYear) {
            sessionStorage.clear();
            navigate('/')
          }
        },[])


  const [errors, setErrors] = useState({
    newPassword: "",
    oldPassword: "",
    confirmPassword:"",
  });

        const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
 const[oldPassword ,setOldPassword]=useState("");
 const [loading, setLoading] = useState(false);


  // ========Cancel data save==================
  const handleCancel = () => {
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setErrors("");
  };

 const handleSubmit = async () => {
      let isValid = true;
      const errorObj = {};
  
      if (!oldPassword) {
        isValid = false;
        errorObj.oldPassword = "Old Password is required *";
      }
      if (!newPassword) {
        isValid = false;
        errorObj.newPassword = "New Password is required *";
      }
      if (!confirmPassword) {
        isValid = false;
        errorObj.confirmPassword = "Confirm Passowrd is required *";
      }
  
      setErrors(errorObj); // Set error messages
  
      if (!isValid) return;
  
      if (newPassword !== confirmPassword) {
        toast.error("Passwords do not match!");
        return;
      }
      setLoading(true);
      try {
        const response = await axios.put(`${ChangePasswordAdd}?id=${userId}&oldPassword=${oldPassword}&newPassword=${newPassword}`);
  
        if (response.data === "UPDATED") {
          toast.success("Password Changed Successfully!");
        
          handleCancel();
        } else if (response.data === "NOTFOUND") {
          toast.warn("Old Password Invalid!");
        
        }
      } catch (error) {
        console.error("Error during API call:", error);
        toast.error("Error occurred while updating data");
        

      }
      finally{
        setLoading(false);
      }
    };
  
        //===================================
const navbg = {
    backgroundColor:"#f79400",
    boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
    display: "flex",
    alignItems: "center",
    padding: "5px 10px",
    fontSize: "19px",
    color:"#fff"
  }
  //=====================================================
  return (
    <>
 <AdminNavbar />

<div className="p-0 m-0">
    <div
      className="row m-0"
      style={navbg}
    >
      <div
        className="col-12 "
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "start",
        }}
      >
        <span className="px-md-5" style={{flexGrow:1}}>
          {" "}
          <MdPassword /> &nbsp; Change Password
        </span>
         <span><TitleNavbar/></span>
      </div>


    </div>

   
    <div className='row m-0 p-0 pt-5'>
          <div className='col-12 col-lg-3'></div>
          <div className='col-12 col-lg-6'>
            <div className="row px-md-5 mt-3  m-0">

            <div className="col-12 pt-2">
              <div className="row m-0">
                <div className="col-4 p-0 lableStyle">
                  <label className="labels">Old Password :</label>
                </div>
                <div className="col-9 col-lg-6">
                <Input.Password
        id="oldPassword"
        value={oldPassword}
        placeholder="Enter  password"
              
                onChange={(e) => setOldPassword(e.target.value)}
       
    />   
                  {errors.oldPassword && (
                    <div className="errorField">{errors.oldPassword}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-12 pt-2">
              <div className="row m-0">
                <div className="col-4 p-0 lableStyle">
                  <label className="labels">New Password :</label>
                </div>
                <div className="col-9 col-lg-6">
                <Input.Password
                id="newPassword"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              /> 
                  {errors.newPassword && (
                    <div className="errorField">{errors.newPassword}</div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-12 pt-2">
              <div className="row m-0">
                <div className="col-4 p-0 lableStyle">
                  <label className="labels">Confirm Password :</label>
                </div>
                <div className="col-9 col-lg-6">
                <Input.Password
                id="confirmPassword"
                placeholder="Again enter new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              /> 
                  {errors.confirmPassword && (
                    <div className="errorField">{errors.confirmPassword}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-12 text-center pt-3">
              <Button
                type="submit"
                className="CancelBtn mx-1"
                onClick={handleCancel}
              >
                Cancel
              </Button>
            
              <Button
                type="submit"
                className="SubmitBtn mx-1"
                onClick={handleSubmit}
                disabled={loading} // Disable button while loading
      >
        {loading ? <Spin size="small" /> : 'Save'}
       
              </Button>
           
            </div>

            <div
              className="col-12 p-0 mt-3"
              style={{ borderBottom: "2px solid #bfb597" }}
            ></div>
          </div>
      </div>
      <div className='col-12 col-md-2 col-lg-4'></div>
    </div></div>


    </>
  )
}

export default ChangePassword